
import React from 'react';
import TeacherCardV2 from './card/TeacherCardV2';

interface TeacherCardProps {
  teacher: {
    id: string;
    name: string;
    email: string;
    phone: string;
    profileImage?: string;
    qualifications?: string[];
    department?: string;
    bio?: string;
  };
  onDeleteSuccess?: () => void;
}

const TeacherCard: React.FC<TeacherCardProps> = ({ teacher, onDeleteSuccess }) => {
  return <TeacherCardV2 teacher={teacher} onDeleteSuccess={onDeleteSuccess} />;
};

export default TeacherCard;
